import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AdminStats } from '@/types/adminUsers';
import styles from './styles.module.scss';

interface StatCardProps {
  tone: 'blue' | 'green' | 'yellow' | 'red';
  iconPath: string;
  label: string;
  value: number;
}

const StatCard: React.FC<StatCardProps> = ({ tone, iconPath, label, value }) => (
  <div className={styles.statCard}>
    <div className={`${styles.statIcon} ${styles[tone]}`}>
      <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width={32} height={32} aria-hidden="true">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={iconPath} />
      </svg>
    </div>
    <dl className={styles.statInfo}>
      <dt className={styles.statLabel}>{label}</dt>
      <dd className={styles.statValue}>{value}</dd>
    </dl>
  </div>
);

export interface UsersStatsGridProps {
  stats: AdminStats['users'];
}

/** Desktop stat cards above the admin users table. */
export const UsersStatsGrid: React.FC<UsersStatsGridProps> = ({ stats }) => {
  const { t } = useTranslation('admin');
  return (
    <div className={styles.statsGrid}>
      <StatCard
        tone="blue"
        iconPath="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z"
        label={t('statTotalUsers')}
        value={stats.total}
      />
      <StatCard
        tone="green"
        iconPath="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        label={t('statVerified')}
        value={stats.verified}
      />
      <StatCard
        tone="yellow"
        iconPath="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L4.34 16.5c-.77.833.192 2.5 1.732 2.5z"
        label={t('statPending')}
        value={stats.pending}
      />
      <StatCard
        tone="red"
        iconPath="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728"
        label={t('statBlocked')}
        value={stats.blocked}
      />
    </div>
  );
};

export default UsersStatsGrid;
